export enum Flp360Status {
    ACTIVE = 1,
    CANCELLED = 2,
    NO_SUBSCRIPTION = 3,
    RESTRICTED = 4
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/flp360-status.enum.ts